import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskCartFunnelInputTextBlockConfig } from '@front-platform/content-builder';
import { kioskCartFunnelInputTextBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';

import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface KioskCartFunnelInputTextBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type KioskCartFunnelInputTextBlockConfigInput = Partial<
  Omit<KioskCartFunnelInputTextBlockConfig, keyof KioskCartFunnelInputTextBlockRuntimeConfig> &
    KioskCartFunnelInputTextBlockRuntimeConfig
>;
export type KioskCartFunnelInputTextBlockResolvedConfig = Omit<
  KioskCartFunnelInputTextBlockConfig,
  keyof KioskCartFunnelInputTextBlockRuntimeConfig
> &
  Partial<KioskCartFunnelInputTextBlockRuntimeConfig>;
export interface KioskCartFunnelInputTextBlockContract extends ConfigComponentContract<
  KioskCartFunnelInputTextBlockConfigInput,
  KioskCartFunnelInputTextBlockResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-cart-funnel-input-text-block',
  templateUrl: './kiosk-cart-funnel-input-text-block.component.html',
  standalone: false,
})
export class KioskCartFunnelInputTextBlockComponent
  implements OnInit, KioskCartFunnelInputTextBlockContract
{
  readonly config = input<KioskCartFunnelInputTextBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskCartFunnelInputTextBlockConfig,
    KioskCartFunnelInputTextBlockRuntimeConfig
  >(kioskCartFunnelInputTextBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get label(): string {
    return this.resolvedConfig()['label'] as unknown as string;
  }
  get placeholder(): string {
    return this.resolvedConfig()['placeholder'] as unknown as string;
  }
  get inputCharset(): 'text' | 'numeric' {
    return this.resolvedConfig()['input_charset'] === 'numeric' ? 'numeric' : 'text';
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }
  get color(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }

  value: string | boolean = '';

  constructor(private cartFunnelDispatcher: CartFunnelStoreDispatcher) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: true,
      formId: this.formId,
      required: this.required,
    });
  }

  onValueChange(_value: string | boolean): void {
    const next =
      this.inputCharset === 'numeric' && typeof _value === 'string'
        ? _value.replace(/\D/g, '')
        : _value;
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: next,
      },
    });
  }
  forceType(data: any): any {
    return data as any;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskCartFunnelInputTextBlockComponent, {
  'keyAliases': {},
});
